import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'sonner';
import { ScrollToTop } from "@/components/ScrollToTop";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Landing } from "@/pages/Landing";
import { Home } from "@/pages/Home";
import { About } from "@/pages/About";
import { Locations } from "@/pages/Locations";
import { Properties } from "@/pages/Properties";
import { Inquiry } from "@/pages/Inquiry";
import { Rules } from "@/pages/Rules";
import { Contact } from "@/pages/Contact";
import { AdminPanel } from "@/pages/AdminPanel";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={
            <>
              <Navbar />
              <AdminPanel />
              <Footer />
            </>
          } />
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/locations" element={<Locations />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/properties/:id" element={<Properties />} />
                <Route path="/inquiry" element={<Inquiry />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
